// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__20lKo","title":"AfterFrontImage_title__1Fyxc"};